<template>
  <!-- Карточка кампании дилера: общая для портала (окно у клиента) и админки (предпросмотр),
       чтобы предпросмотр рисовался тем же кодом, что видит клиент. Без i18n и API:
       тексты и действия приходят снаружи -->
  <article class="campaign-card">
    <img v-if="imageUrl" class="campaign-card__image" :src="imageUrl" alt="" />
    <div class="campaign-card__content">
      <h2 class="campaign-card__title">{{ title }}</h2>
      <!-- bodyHtml прошёл санитайзер на сервере (теги редактора, https-ссылки без атрибутов) -->
      <div v-if="bodyHtml" class="campaign-card__body" v-html="bodyHtml"></div>
      <p v-if="doneText" class="campaign-card__done">
        <span class="material-symbols-outlined">check_circle</span>
        {{ doneText }}
      </p>
      <button
        v-else-if="buttonText"
        type="button"
        class="campaign-card__button"
        :disabled="buttonBusy"
        @click="$emit('action')"
      >
        {{ buttonText }}
      </button>
    </div>
  </article>
</template>

<script setup>
defineProps({
  imageUrl: { type: String, default: null },
  title: { type: String, default: '' },
  bodyHtml: { type: String, default: '' },
  // Пустой текст кнопки = кампания без кнопки
  buttonText: { type: String, default: '' },
  buttonBusy: { type: Boolean, default: false },
  // После «Хочу»: вместо кнопки подтверждение
  doneText: { type: String, default: '' },
})

defineEmits(['action'])
</script>

<style scoped>
.campaign-card {
  overflow: hidden;
  background: var(--bg-card);
  color: var(--text-primary);
}

.campaign-card__image {
  display: block;
  width: 100%;
  max-height: 320px;
  object-fit: cover;
}

.campaign-card__content {
  padding: 20px 22px 22px;
}

.campaign-card__title {
  margin: 0 0 10px;
  font-size: 1.25rem;
  line-height: 1.3;
  color: var(--text-heading);
}

.campaign-card__body {
  font-size: 0.95rem;
  line-height: 1.55;
  color: var(--text-secondary);
  overflow-wrap: anywhere;
}

.campaign-card__body :deep(p),
.campaign-card__body :deep(div) {
  margin: 0 0 8px;
}

.campaign-card__body :deep(ul),
.campaign-card__body :deep(ol) {
  margin: 0 0 8px;
  padding-left: 20px;
}

.campaign-card__body :deep(a) {
  color: var(--primary);
}

/* Визуальный редактор: заголовки, разделитель, картинки в тексте (ширина и отступы
   приходят инлайн-стилем от сервера, здесь только страховка от выхода за колонку) */
.campaign-card__body :deep(h2),
.campaign-card__body :deep(h3) {
  margin: 12px 0 6px;
  line-height: 1.3;
  color: var(--text-heading);
}

.campaign-card__body :deep(h2) {
  font-size: 1.15rem;
}

.campaign-card__body :deep(h3) {
  font-size: 1.02rem;
}

.campaign-card__body :deep(hr) {
  margin: 12px 0;
  border: 0;
  border-top: 1px solid var(--border-default);
}

.campaign-card__body :deep(img) {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

.campaign-card__body :deep(strong),
.campaign-card__body :deep(b) {
  color: var(--text-primary);
}

.campaign-card__button {
  width: 100%;
  margin-top: 14px;
  padding: 12px 18px;
  border: none;
  border-radius: 10px;
  background: var(--primary);
  color: var(--text-inverse);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}

.campaign-card__button:hover:not(:disabled) {
  background: var(--primary-hover);
}

.campaign-card__button:disabled {
  opacity: 0.6;
  cursor: default;
}

.campaign-card__done {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 14px 0 0;
  padding: 12px 14px;
  border-radius: 10px;
  background: var(--success-light);
  color: var(--success-text);
  font-weight: 600;
}

@media (min-width: 640px) {
  .campaign-card__button {
    width: auto;
    min-width: 200px;
  }
}
</style>
